import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItemComponent } from './menu-item.component';
import { RouterModule } from '@angular/router';
import { MenuItemDirective } from './menu-item.directive';


@NgModule({
  declarations: [MenuItemComponent, MenuItemDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    RouterModule,
    TranslateModule
  ],
  exports: [MenuItemComponent]
})
export class MenuItemModule {
}
